import React, { memo } from 'react'
import { AppBar, Box, styled, Toolbar } from '@mui/material'
import { Logo } from '../components'
import { translate } from '../i18n'
import { AccountButton } from './AccountButton'
import { InternAppBarProps } from './InternAppBar.types'
import { MenuButton } from './MenuButton'

const CustomAppBar = styled(AppBar)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: `0px 2px 5px 1px ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
}))

function InternAppBar({ email, onSignOut }: InternAppBarProps) {
    return (
        <CustomAppBar position="fixed" color="inherit">
            <Toolbar variant="dense" disableGutters={false}>
                <MenuButton />

                <Box sx={{ minWidth: { xs: '100px', md: '205px' }, pr: 1 }}>
                    <Logo text={translate('app.title') as string} />
                </Box>

                {/* Relleno */}
                <Box sx={{ flexGrow: 1 }}></Box>

                <AccountButton email={email} onSignOut={onSignOut} />
            </Toolbar>
        </CustomAppBar>
    )
}

export default memo(InternAppBar)
